export default __webpack_public_path__ + "assets/images/5a68318a84ad960e6b9b201cfc903a4a.png";